import React, { memo } from "react";
import { IconButton, TableCell, TableRow } from "@mui/material";
import { Add, ExpandLess } from "@mui/icons-material";

import {
  formatarData,
  formatarValor,
} from "../utils";
import { obterNomeConvenio } from "../../../convenio";

function LinhaNotaFiscal({ row, isExpanded, onToggleExpand }) {
  return (
    <TableRow hover>
      <TableCell align="center">
        <IconButton
          size="small"
          aria-label={
            isExpanded
              ? "Recolher detalhes da nota fiscal"
              : "Expandir detalhes da nota fiscal"
          }
          onClick={onToggleExpand}
        >
          {isExpanded ? <ExpandLess fontSize="small" /> : <Add fontSize="small" />}
        </IconButton>
      </TableCell>
      <TableCell align="center">{row.nota_fiscal}</TableCell>
      <TableCell align="center">{formatarValor(row.valor)}</TableCell>
      <TableCell align="center">{formatarData(row.data)}</TableCell>
      <TableCell align="center">{row.codigo_nota}</TableCell>
      <TableCell align="center">
        {obterNomeConvenio({
          convenio: row.plano || row.convenio,
          nome_convenio: row.nome_convenio,
        })}
      </TableCell>
    </TableRow>
  );
}

export default memo(LinhaNotaFiscal);
